<template>
	<div>
		<div>

      <h3
        v-html="`Account`"
      />
      <p>Nome: {{ user.firstname }}</p>
      <p>Cognome: {{ user.lastname }}</p>
      <p>Email: {{ user.email }}</p>
      <hr>
      <password class="tag-partner" :user="user"/>
      <hr>

      <payment :user="user"/>
      <hr>

			<section class="mt-5">
				<p>
					<i>Cancella iscrizione: se non vuoi più utilizzare Quomi, puoi richiedere la cancellazione permanente dal servizio. Non potrai riattivare il tuo profilo. Vuoi procedere? Clicca su questo link: <span class="link-detail" @click="$refs.modalDelete.open()">Cancella profilo</span>.</i>
				</p>
			</section>


      <!--<section class="mt-5">
         <b>Offerte promozionali</b>
          <v-switch
            v-model="value"
            inset
            color="green"
            :label="`${value ? 'Consento' : 'Non Consento'}`"
            @change="changeValue"
            :loading="loading"
          ></v-switch>
          <p>
              Acconsento all’uso dei miei dati personali per ricevere promozioni esclusive e proposte personalizzate
          </p>
      </section>-->


		</div>


		<!--<general-error />-->

		<modal-delete-abo
			ref="modalDelete"
			:user="user"
		/>

	</div>
</template>

<script>
import { UserApi } from '@/api/UserApi'
import ModalDeleteAbo from './ModalDeleteAbo'
import HomeWidget from '../Home/HomeWidget'
import Payment from './Payment'
import Password from './Password'

export default {
	mixins: [
	],

	components: {
    Password,
    Payment,
    HomeWidget,
		ModalDeleteAbo,
	},

	data () {
		return {
      loading: false,
      value: false,
		}
	},

	computed: {
		user () {
			return this.$root.user
		},
	},
  methods: {
    changeValue() {
      this.loading = true;

      var um = new UserApi()
      um.changeConsentMarketing({consent_marketing: this.value}).then(response => {
      }).then(response => {
        this.user.consent_marketing = this.value;
        this.loading = false;
      })
    }
  },
  mounted() {
    this.value = this.user.consent_marketing;
  }
}

</script>